import(/* webpackMode: "eager", webpackExports: ["SponsorClient"] */ "/vercel/path0/app/sponsor/sponsor-client.tsx");
